/* Notification Modal JavaScript */
/* Created: 2025-01-21 */

class NotificationModal {
    constructor() {
        this.init();
    }

    init() {
        this.setupEventListeners();
    }

    setupEventListeners() {
        // Кнопка OK для модального окна уведомлений
        const notificationOkBtn = document.getElementById('notification-ok-btn');
        if (notificationOkBtn) {
            notificationOkBtn.addEventListener('click', () => {
                this.hideNotification();
            });
        }
        
        // Клик вне модального окна уведомлений для закрытия
        const notificationModal = document.getElementById('notification-modal');
        if (notificationModal) {
            notificationModal.addEventListener('click', (e) => {
                if (e.target === notificationModal) {
                    this.hideNotification();
                }
            });
        }
    }

    showNotification(message, title = 'Notification', icon = '⚠️') {
        // Show notification modal instead of alert
        const modal = document.getElementById('notification-modal');
        const messageElement = document.getElementById('notification-message');
        const titleElement = document.querySelector('.notification-title');
        const iconElement = document.querySelector('.notification-icon');
        
        if (modal && messageElement && titleElement && iconElement) {
            messageElement.textContent = message;
            titleElement.textContent = title;
            iconElement.textContent = icon;
            modal.style.display = 'flex';
        } else {
            // Fallback to alert if modal elements not found
            alert(`${icon} ${title}\n\n${message}`);
        }
    }

    hideNotification() {
        const modal = document.getElementById('notification-modal');
        if (modal) {
            modal.style.display = 'none';
        }
    }
}

// Инициализация при загрузке DOM
document.addEventListener('DOMContentLoaded', () => {
    window.notificationModal = new NotificationModal();
});
